
// this is the difference between the .net ticks and the javascript Date ticks
const TICKS_CONVERSION_CONSTANT = 62135596800000;

/**
 * Given the .Net ticks of a date, convert it to a Date
 */
export function getDateFromDotNetTicks(dotNetTicks: number): Date {
    let ticksInMilliseconds = (dotNetTicks / 10000) - TICKS_CONVERSION_CONSTANT;

    return new Date(ticksInMilliseconds);
}
